export default {
    title: 'Reset your password',
    title_submitted: 'Done! Check your email.',
    subtitle: 'We’ll email you instructions to reset your password.',
    buttons: {
        back_to_login: 'Back to login',
    },
    notifications: {
        email_sent: 'We’ve sent an email to ',
        with_instructions: ' with password reset instructions.',
    },
}
